var React = require('react');

function OpenInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.43945 1.76813L30.267 1.76813L30.267 30.5957","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M30.2675 1.76817L0.865234 31.1704","stroke":"black","strokeWidth":"2","strokeMiterlimit":"10","key":1})]);
}

OpenInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = OpenInline;

OpenInline.default = OpenInline;
